import * as React from 'react';
import PropTypes from 'prop-types';
import { Panel, Header, Text, Image, FlexGrid } from '@gasbuddy/react-components';
import { useTranslation } from 'react-i18next';
import timeAgo from '../../utils/timeAgo';
// import UpdateAvailabilityModal from '../UpdateAvailabilityModal';
import StatusIcons from '../StatusIcons';
import EmergencyStatusPropType from '../../utils/prop-types/emergency-status';
import getLastEmergencyUpdateDate from '../../utils/getLastEmergencyUpdateDate';

import styles from './StationListItem.module.css';

export default function StationListItem({
  address,
  brandName = null,
  distance,
  emergencyStatus = {},
  fuels = [],
  icon = 'https://images.gasbuddy.com/b/1/0/wp/logo.png',
  id, // eslint-disable-line no-unused-vars
  name,
  phone = null,
  ...other
}) {
  const { t } = useTranslation(['station', 'miscellaneous']);
  const lastUpdateTimestamp = getLastEmergencyUpdateDate(emergencyStatus);

  return (
    <Panel color="white" raised padded rounded bordered className={styles.stationListItem} {...other}>
      <Image
        src={icon}
        alt={brandName || name}
        className={styles.logo}
      />
      <Header as="h3" snug>{name}</Header>
      {!!lastUpdateTimestamp && (
        <Text as="p" size="sm" suppressHydrationWarning data-testid="lastUpdateTimestamp">
          {`${t('updated', { ns: 'miscellaneous' })} ${timeAgo(new Date(lastUpdateTimestamp))}`}
        </Text>
      )}
      <Text as="p">
        {address.line_1}
        {address.line_2 ? ` ${address.line_2}` : ''}
      </Text>
      {phone && (
        <Text as="p">
          <Text as="a" href={`tel:${phone}`}>{phone}</Text>
        </Text>
      )}
      {!lastUpdateTimestamp && !phone && (
        <br />
      )}
      <FlexGrid className={styles.bottomContent}>
        <FlexGrid.Column mobile={8}>
          <StatusIcons emergencyStatus={emergencyStatus} fuels={fuels} />
          {/* <span className={styles.updateLinkContainer}>
            <UpdateAvailabilityModal
              stationId={id}
              includeDiesel={fuels.includes('diesel')}
              link
            />
          </span> */}
        </FlexGrid.Column>
        <FlexGrid.Column mobile={4} className={styles.distance}>
          <Text>{`${distance.toFixed(2)} mi`}</Text>
        </FlexGrid.Column>
      </FlexGrid>
    </Panel>
  );
}

StationListItem.propTypes = {
  id: PropTypes.number.isRequired,
  icon: PropTypes.string,
  name: PropTypes.string.isRequired,
  brandName: PropTypes.string,
  address: PropTypes.shape({
    line_1: PropTypes.string.isRequired,
    line_2: PropTypes.string,
  }).isRequired,
  distance: PropTypes.number.isRequired,
  phone: PropTypes.string,
  fuels: PropTypes.arrayOf(PropTypes.string),
  emergencyStatus: EmergencyStatusPropType,
};
